// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"c3836fb1","341":"d04918e4","438":"39bbd81a","706":"1c886459","726":"68241832","790":"87f8d547"}[chunkId] + ".chunk.js";
};